/* @flow */

import { em } from 'polished';

import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  username: {
    marginTop: em(16, baseFontSize),
    marginBottom: em(16, baseFontSize),

    fontWeight: 600,
    WebkitFontSmoothing: 'antialiased',
  },
  action: {
    marginTop: em(8, baseFontSize),
    marginBottom: em(8, baseFontSize),
  },
};
